// k4
export const PAGE_JOBS = 'page-jobs';

// lokarb
export const CREATE_CV = 'create-cv';
export const CV_PREVIEW = 'cv-preview';
export const PAGE_DEBUG = 'page-debug';
export const PAGE_ERROR = 'page-error';
export const PAGE_ERROR_ALREADY_SENT = 'page-error-already-sent';
export const PAGE_FORM = 'page-form';
export const PAGE_CUSTOM_FIELDS = 'page-custom-fields';
export const PAGE_PREVIEW = 'page-form-preview';
export const PAGE_SUCCESS = 'page-success';
export const PAGE_SENDING = 'page-sending';
